import React from 'react';
import { IconProps } from '.';

const SvgInfo = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='M11 10v10h2V10h-2ZM11 4v3h2V4h-2Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgInfo;
